module.exports = __webpack_public_path__ + "static/media/kiss-wink-heart.9a2c6e5d.svg";